export const SPONSOR_LOGO = 'SPONSOR_LOGO';
export const RIGHTSHOLDER_PLACEMENT_EXAMPLE = 'RIGHTSHOLDER_PLACEMENT_EXAMPLE';

const s3Config = (uploadType, data, file) => {
    const { name, type } = file;
    const config = {
        originalName: name,
        contentType: type,
    };
    switch (uploadType) {
        case RIGHTSHOLDER_PLACEMENT_EXAMPLE:
            config.uploadTypeId = 7;
            config.bucketFolder = 'rightsholder_placement_examples';
            config.fileName = `${data.rhId}-${Date.now()}-${name}`;
            break;
        case SPONSOR_LOGO:
            config.uploadTypeId = 2;
            config.bucketFolder = 'sponsors-logos';
            config.fileName = `${data.sponsorId}-${Date.now()}-${name}`;
            break;
        default:
            return null;
    }
    return config;
};

export default s3Config;
